import { Link } from "react-router-dom";
import { BadgeCheck, Languages, MapPin, Star } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { API, useApi } from "@/lib/api";

export const mediaUrl = (path) => `${API}/media/${path}`;
export const CAT_KEY = { driver: "pt_driver", fleet: "pt_fleet", guide: "pt_guide", accommodation: "pt_acc" };

export function PartnerCard({ p, i = 0 }) {
  const { t } = useLang();
  return (
    <Link to={`/mitra/${p.slug}`} data-testid={`partner-card-${p.slug}`} className="group overflow-hidden rounded-3xl border border-slate-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl fade-up" style={{ animationDelay: `${i * 60}ms` }}>
      <div className="aspect-[4/3] overflow-hidden bg-emerald-50">
        {p.photos[0] && <img src={mediaUrl(p.photos[0])} alt={p.display_name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
      </div>
      <div className="space-y-1.5 p-5">
        <p className="flex items-center gap-1.5 font-bold text-slate-900">{p.display_name}<BadgeCheck className="h-4 w-4 text-emerald-600" />
          {p.rating && <span data-testid={`partner-card-rating-${p.slug}`} className="ml-auto inline-flex items-center gap-0.5 text-sm"><Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />{p.rating} <span className="text-xs font-normal text-slate-400">({p.review_count})</span></span>}</p>
        <p className="text-xs font-semibold uppercase tracking-wider text-[#D97706]">{t(CAT_KEY[p.category])}</p>
        <p className="flex items-center gap-1 text-sm text-slate-500"><MapPin className="h-3.5 w-3.5" />{t(`city_${p.city}`)}</p>
        {p.languages.length > 0 && <p className="flex items-center gap-1 text-sm text-slate-600"><Languages className="h-3.5 w-3.5" />{p.languages.join(" · ")}</p>}
      </div>
    </Link>
  );
}

export function VerifiedPartners() {
  const { t } = useLang();
  const { data } = useApi("/partners");
  if (!data?.length) return null;
  return (
    <section data-testid="verified-partners" className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
      <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{t("pt_verified_title")}</h2>
      <p className="mt-2 text-slate-500">{t("pt_verified_sub")}</p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">{data.map((p, i) => <PartnerCard key={p.slug} p={p} i={i} />)}</div>
    </section>
  );
}
